// extracted by mini-css-extract-plugin
export default {"SliderItem":"SliderItem_SliderItem__pGKIr","ActiveSliderItem":"SliderItem_ActiveSliderItem__a2d7o"};